/**
 * Enum holding UI Theme.
 */
export enum ReportTheme {
  Light,
  Dark,
}
